
























import ApplicationLayoutFluid from "@/layouts/ApplicationLayoutFluid.vue";
import ApplicationModule from "@/store/modules/application";
import RateChangesModule from "@/store/modules/rate-changes";
import ChangeSetsTable from "@/views/rate-changes/components/ChangeSetsTable.vue";
import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import { ApplicationState } from "@/models";

const application = namespace(ApplicationModule.name);
const rateChanges = namespace(RateChangesModule.name);

@Component({
  name: "RateChangesIndex",
  components: { ChangeSetsTable, ApplicationLayoutFluid }
})
export default class RateChanger extends Vue {
  // ===== Store ===== //
  @State("application") private readonly application!: ApplicationState;
  @application.Action("getFacilities") public getFacilities!: () => void;
  @application.Action("getFacilityUnitTypes") public getFacilityUnitTypes!: () => void;
  @rateChanges.Action private getIPRCSets!: () => void;
  // ===== Props ===== //

  // ===== Data ===== //

  // ===== Methods ===== //
  private toCreate(): void {
    this.$router.push({ name: "createChange" }).catch(() => { return true; });
  }
  // ===== Computed ===== //

  // ===== Lifecycle Hooks ===== //
  private mounted(): void {
    this.getIPRCSets();
    this.getFacilities();
    this.getFacilityUnitTypes();
  }
}
